
import React from "react";

const Logo = () => {
  return (
    <div className="flex items-center gap-2">
      <img 
        src="icons/icon.svg" 
        alt="HintWord" 
        className="w-8 h-8" 
      />
      <span className="text-2xl font-bold text-primary">intword</span>
    </div>
  );
};

export default Logo;
